import { Box } from "@mui/material";
import { useAtom, useSetAtom } from "jotai";
import { formDataAtom, otherErrorsAtom, updateFieldAtom } from "../store/onboardingModalStore";
import { currentToolOptions, currentToolSubtitles } from "../constants/chipData";
import { OnboardingSelectionChip } from "./shared/OnboardingSelectionChip";
import { OnboardingStepLayout } from "./shared/OnboardingStepLayout";
import { OnboardingOtherInput } from "./shared/OnboardingOtherInput";

export const OnboardingCurrentTool = (): JSX.Element | null => {
  const [formData] = useAtom(formDataAtom);
  const updateField = useSetAtom(updateFieldAtom);
  const [otherErrors, setOtherErrors] = useAtom(otherErrorsAtom);

  const orgType = formData.orgType;
  if (!orgType) return null;

  const options = currentToolOptions[orgType];
  const subtitle = currentToolSubtitles[orgType];
  const isOtherSelected = formData.currentTools.includes("other");
  const isNoneDisabled = formData.currentTools.some((v) => v !== "none");

  const handleToggle = (value: string): void => {
    const current = formData.currentTools;

    if (value === "none") {
      if (current.includes("none")) {
        updateField({ currentTools: current.filter((v) => v !== "none") });
      } else {
        updateField({ currentTools: ["none"] });
        const { currentTools: _, ...rest } = formData.otherTexts;
        updateField({ otherTexts: rest });
      }
      return;
    }

    const withoutNone = current.filter((v) => v !== "none");
    const updated = withoutNone.includes(value)
      ? withoutNone.filter((v) => v !== value)
      : [...withoutNone, value];
    updateField({ currentTools: updated });

    if (value === "other" && current.includes("other")) {
      const { currentTools: _, ...rest } = formData.otherTexts;
      updateField({ otherTexts: rest });
    }
  };

  return (
    <OnboardingStepLayout title="What are you using currently?" subtitle={subtitle}>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
        {options.map((option) => (
          <OnboardingSelectionChip
            key={option.value}
            label={option.label}
            isSelected={formData.currentTools.includes(option.value)}
            onClick={() => handleToggle(option.value)}
            showCheck
            disabled={option.value === "none" && isNoneDisabled}
          />
        ))}
      </Box>
      {isOtherSelected && (
        <Box sx={{ marginTop: "8px" }}>
          <OnboardingOtherInput
            value={formData.otherTexts.currentTools ?? ""}
            onChange={(val) =>
              updateField({
                otherTexts: { ...formData.otherTexts, currentTools: val },
              })
            }
            error={!!otherErrors.currentTools}
            onErrorClear={() => {
              const { currentTools: _, ...rest } = otherErrors;
              setOtherErrors(rest);
            }}
          />
        </Box>
      )}
    </OnboardingStepLayout>
  );
};
